export default __webpack_public_path__ + "static/media/AprDom2024.4f302ad5.png";